import {useRef, useEffect} from "react";

export const useJustChanged = (fn, {model, prop}) => {
  const fnRef = useRef(fn);
  useEffect(() => {
    fnRef.current = fn;
  }, [fn]);

  const value = model && model[prop] && (model[prop].id || model[prop]);
  const isActive = model && model.$meta.get(prop, undefined) !== undefined;
  const context = model && model.id;

  const prevRef = useRef({value, context});

  useEffect(() => {
    const prev = prevRef.current;
    if (isActive && prev.value !== value && prev.context === context) {
      fnRef.current();
    }
  }, [value, isActive, context]);

  useEffect(() => {
    prevRef.current = {value, context};
  }, [value, context]);
};
